module.exports = __webpack_public_path__ + "img/planeta.350a7c51.png";